import { toast } from "react-toastify";

import apiService from "../../../../services/apiService";
import { IStation } from "../../../../models/IUser";
import { notify } from "../../../../shared/lib/notify";
import { pollingErrorMessage } from "../../../../utils/pollingError";

/**
 * `S.2`, `УИ.1`: переключатель опроса станции в окне модуля. Выключение — с
 * системным подтверждением (`notify.confirm`): станция перестанет опрашиваться
 * и ток ей распределяться не будет. Закрытие окна подтверждения и автозакрытие
 * ничего не шлют, `PATCH` уходит только по «OK». Включение — сразу.
 *
 * Вынесено из `PopupModule` (`АУД-Н344`), чтобы поведение проверялось
 * отрисовкой настоящего окна подтверждения, а не поиском строк в исходнике.
 */
export function usePollingToggle({
  markPollingPending,
  refreshData,
}: {
  markPollingPending: (id: number, enabled: boolean) => void;
  refreshData?: () => void;
}) {
  return async (station: IStation) => {
    const enabled = station.polling_enabled === false;
    const number = station.controller_address ?? station.id;

    const applyPolling = async () => {
      try {
        await apiService.PATCH(`/station/${station.id}/polling`, { enabled });
        // `R.7`: сразу «Применяется…», затем перечитываем строку.
        markPollingPending(station.id, enabled);
        if (refreshData) refreshData();
      } catch (error: any) {
        toast.error(pollingErrorMessage(error, number));
      }
    };

    if (!enabled) {
      notify.confirm({
        message: `Станция ${number} перестанет опрашиваться, ток ей распределяться не будет`,
        onConfirm: applyPolling,
      });
      return;
    }

    await applyPolling();
  };
}
